
import React from 'react';
import { useLanguage } from "@/hooks/useLanguage";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface DashboardErrorProps {
  error: Error | null;
  refetch: () => void;
  isRefetching: boolean;
}

export function DashboardError({ error, refetch, isRefetching }: DashboardErrorProps) {
  const { t } = useLanguage();
  
  return (
    <div className="space-y-6">
      <Alert variant="destructive">
        <AlertTitle>{t('common.error')}</AlertTitle>
        <AlertDescription className="flex flex-col gap-4">
          <p>{error?.message || 'Failed to load dashboard data'}</p>
          <Button 
            variant="outline" 
            onClick={() => refetch()} 
            disabled={isRefetching}
            className="w-fit"
          >
            {isRefetching ? (
              <>
                <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
                {t('common.loading')}
              </>
            ) : (
              t('common.reset')
            )}
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
}
